module.exports = __webpack_public_path__ + "img/rewardBg.0aadb449.png";